var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"img-canvas"},[_c('canvas',{ref:"shareResume"}),_c('canvas',{ref:"addResume"})])])}
var staticRenderFns = []

export { render, staticRenderFns }